module.exports = __webpack_public_path__ + "images/emoji/stars.222d8909f75579370dad.png";